<template>
  <div id="update-price">

      <div v-if="passwordRequired"><br>
          <span style="font-size: 1.2em" class="badge badge-success"><span class="fa fa-check"></span> Station Owner Manages Updates</span><br><br>

          <p class="alert alert-light">If this station is not being kept up to date, please contact <a href="mailto:hello@autogas.app">hello@autogas.app</a>.</p>

          <details>
              <summary class="">Are you the owner?</summary>

              <b-button v-if="!priceUpdated && !priceUpdating && price > 0" class="btn btn-success" v-b-modal.confirm-price-modal><span class="fa fa-check"></span> Confirm Availability at Current Price</b-button>
              <b-button v-if="!priceUpdated && !priceUpdating" class="btn btn-success" v-b-modal.update-price-modal><span class="fa fa-credit-card"></span> Update Price or Availability</b-button>
              <router-link :to="'/edit-station/' + stationId"><b-button class="btn btn-success"><span class="fa fa-edit"></span> Update Other Info</b-button></router-link>
          </details>
      </div>

      <div v-if="!passwordRequired">
          <b-button v-if="!priceUpdated && !priceUpdating && price > 0" class="btn btn-success" v-b-modal.confirm-price-modal><span class="fa fa-check"></span> Confirm Availability at Current Price</b-button>
          <b-button v-if="!priceUpdated && !priceUpdating" class="btn btn-success" v-b-modal.update-price-modal><span class="fa fa-credit-card"></span> Update Price or Availability</b-button>
          <router-link :to="'/edit-station/' + stationId"><b-button class="btn btn-success"><span class="fa fa-edit"></span> Update Other Info</b-button></router-link>
      </div>

    <b-modal v-if="!priceUpdated && !priceUpdating" id="update-price-modal" title="Update Price" @ok="savePrice()">
      <p>Updating the price per litre helps others find the best places to fill up.</p>

      <b-form inline class="justify-content-center">
        <b-form-group class="text-center" :label="'What is the price per litre for Autogas at ' + name + '?'">
          <b-form-input type="number" min="1" max="999" step="0.1" pattern="^\d*(\.\d{0,1})?$" v-model="price"></b-form-input> pence
        </b-form-group>
        <br><br>
        <div class="alert alert-warning" id="unavailableInfo">
          If LPG is temporarily unavailable, please enter a price of 0.
        </div>
        <br><br>
        <div v-if="passwordRequired" class="alert alert-warning">
            <b-form-group class="text-center" :label="'This station can only be modified by its owner. If you are the owner, please supply the password:'">
              <b-form-input type="text" v-model="password"></b-form-input>
            </b-form-group>
        </div>
      </b-form>
    </b-modal>

      <b-modal v-if="!priceUpdated && !priceUpdating" id="confirm-price-modal" title="Confirm Availability" @ok="savePrice()">
          <b-form inline class="justify-content-center">
              <p>By pressing OK, you are confirming that autogas is available today, for <strong>{{ price }}</strong> pence per litre, at <strong>{{ stationName }}</strong>.</p>
              <div v-if="passwordRequired" class="alert alert-warning">
                  <b-form-group class="text-center" :label="'This station can only be modified by its owner. If you are the owner, please supply the password:'">
                      <b-form-input type="text" v-model="password"></b-form-input>
                  </b-form-group>
              </div>
          </b-form>
      </b-modal>

    <div class="alert alert-info" v-if="priceUpdating">
      Saving your contribution...
    </div>

    <hr v-if="priceUpdated">

    <div class="alert alert-success" v-if="priceUpdated">
      Thank you for updating the price! Your contributions will help others find cheap Autogas.
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: "UpdatePrice",
    props: {
      'name': String,
      'priceUpdated': Boolean,
      'priceUpdating': Boolean,
      'passwordRequired': Boolean,
      'stationId': Number,
      'stationName': String,
      'price': String
    },
    data() {
      return {
        password: null
      }
    },
    methods: {
      savePrice() {
        var countDecimals = function(value) {
          if(value.toString().split(".").length === 1){
            return 0;
          }
          if (Math.floor(value) !== value)
            return value.toString().split(".")[1].length || 0;
          return 0;
        };

        if(countDecimals(this.price) > 1){
          alert("The price you provided was invalid!");
          return false;
        }else{
          this.priceUpdating = true;
          Vue.axios.post('/api/v1.0/stations/' + this.stationId + '/price', {
            "data": {
              "price": this.price,
              "password": this.password
            }
          }).then((response) => {
            this.priceUpdated = true;
            this.priceUpdating = false;
            this.price = null;
            this.password = null;
          }).catch((error) => {
              this.priceUpdating = false;
              try{
                  if(error.response.status === 401) {
                      alert("This station is locked and can only be updated by the owner. The password provided is not correct.");
                  }
              }catch(e){
                  alert("There has been an error saving your contributions. Please ensure you are connected to the internet and try again.");
              }
          });
        }
      }
    }
  }
</script>

<style scoped>
  #update-price .btn {
    margin: 1mm;
  }
  #unavailableInfo {
    margin-top: 20px;
  }
</style>